var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdficon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1163_9503)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1163_9503",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.584 23.7499V1.24994H1.08398V23.7499H23.584Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1163_9503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0841 1.20313H5.30273C4.52611 1.20313 3.89648 1.83276 3.89648 2.60938V22.3906C3.89648 23.1672 4.52611 23.7968 5.30273 23.7968H19.3652C20.1418 23.7968 20.7714 23.1672 20.7714 22.3906V5.89076L16.0841 1.20313Z",
    stroke: "#7A22A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.084 1.20314V5.89062H20.7715L16.084 1.20314Z",
    stroke: "#7A22A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3337 12.2633L10.0625 16.1972H14.605L12.3337 12.2633ZM12.3337 12.2633L13.382 10.4476C13.8479 9.64063 13.2656 8.63193 12.3337 8.63193C11.4019 8.63193 10.8195 9.64063 11.2855 10.4476L12.3337 12.2633Z",
    stroke: "#7A22A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6055 16.1972L15.6537 18.0128C16.1197 18.8198 17.2844 18.8198 17.7503 18.0128C18.2161 17.2059 17.6338 16.1972 16.702 16.1972H14.6055Z",
    stroke: "#7A22A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0627 16.1972L9.0144 18.0128C8.54846 18.8198 7.38377 18.8198 6.91788 18.0128C6.45199 17.2059 7.03436 16.1972 7.96609 16.1972H10.0627Z",
    stroke: "#7A22A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1163_9503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333984 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdficon);
export default __webpack_public_path__ + "static/media/pdficon.789750a41912d3ac04c34efac1e66106.svg";
export { ForwardRef as ReactComponent };